export default __webpack_public_path__ + "static/media/artist-img3.13301bc2.jpg";